var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"booking-status-indicator"},[_c('md-icon',{staticClass:"status-icon",class:_vm.statusClass},[_vm._v("privacy_tip")]),(_vm.showText)?_c('span',[_vm._v(_vm._s(_vm.statusDescription))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }